import React, { PureComponent } from 'react';
import { Translate } from 'react-localize-redux';
import styled from 'styled-components';

import Heading, { SubHeading } from '../../../components/heading';
import Section from '../section';
/**
 * Videos
 */
import VIDEO_MP4 from './video.mp4';
import VIDEO_WEBM from './video.webm';

/**
 * Section wrapper
 */
const Background = styled.div`
  background: ${props => props.theme.primary};
`;

const Container = styled.div`
  @media (min-width: 768px) {
    margin: 2em auto 0;
    max-width: 40em;
  }
`;

const Video = styled.video`
  max-width: 100%;
  border-radius: 0.2em;
`;

class Trailer extends PureComponent {
  render() {
    return (
      <Background>
        <Section>
          <Heading>HOW TO PLAY</Heading>
          <SubHeading>
            <Translate id="landingPage.trailer.subtitle" />
          </SubHeading>
          <Container>
            <Video autoPlay controls muted playsInline>
              <source src={VIDEO_WEBM} type="video/webm" />
              <source src={VIDEO_MP4} type="video/mp4" />
            </Video>
          </Container>
        </Section>
      </Background>
    );
  }
}

export default Trailer;
